import React from 'react';

import ContentLoader from '@adsk/alloy-react-content-loader';

export const DefaultDisplayUserLoader = () => {
  return (
    <ContentLoader
      data-testid="DisplayUserLoader"
      style={{ height: '8px', width: 'fit-content' }}
    >
      <rect rx="3" ry="3" height="100%" width="100%" />
    </ContentLoader>
  );
};
